<script lang="ts">
	import Media from "@components/common/Media.svelte";
	import email from "@core/assets/icons/mail.svg?raw";
	import mobile from "@core/assets/icons/mobile.svg?raw";
	import phone from "@core/assets/icons/phone - stationary.svg?raw";
	import type { Contact } from "@core/schema/Contact.js";
	import { cleanPhoneNumber, formatPhoneNumber } from "@core/utils/formatPhoneNumber.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./ContactCards.translations.json" with { type: "json" };
	import Formatted from "./common/Formatted.svelte";
	import Icon from "./common/Icon.svelte";

	const { contacts }: { contacts: Contact[] } = $props();
	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(translations);
</script>

<section class="full-width grid-container">
	<h2 class="text-left sm:w-4/5 md:w-3/5 mb-6 sm:mb-8 md:mb-12 lg:mb-16">
		<Formatted text={translate("heading")} />
	</h2>
	<div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-5 md:gap-6">
		{#each contacts as contact (contact.id)}
			<div class="p-4 sm:p-5 md:p-6 bg-zms-grey rounded-2xl gap-4 sm:gap-5 md:gap-6 flex flex-col items-start">
				{#if contact.photo}
					<Media
						height={64}
						width={64}
						alt={contact.name}
						class="w-full h-full"
						wrapperClass="rounded-full overflow-hidden w-14 h-14 sm:w-16 sm:h-16"
						source={contact.photo}
					/>
				{:else}
					<div class="w-14 h-14 sm:w-16 sm:h-16 bg-zms-blue rounded-full"></div>
				{/if}
				<div class="flex flex-col gap-1.5 sm:gap-2">
					<h3 class="text-lg sm:text-xl md:text-[1.25rem]/[1] font-semibold text-zms-blue-dark">{contact.name}</h3>
					<span class="text-zms-blue-dark uppercase text-xs sm:text-sm/[1]">{contact.position[tenant.locale]}</span>
				</div>
				<div class="flex flex-col gap-1.5 sm:gap-2 mt-1 sm:mt-2">
					{#if contact.phone}
						<span class="underline items-end inline-flex text-zms-optical-black">
							<Icon icon={phone} class="inline-block mr-2 sm:mr-3 w-5 h-5 sm:w-6 sm:h-6 text-zms-blue" />
							<a class="font-semibold text-xs sm:text-sm/[1.5]" href={`tel:${cleanPhoneNumber(contact.phone)}`}
								>{formatPhoneNumber(contact.phone)}</a
							>
						</span>
					{/if}
					{#if contact.mobile}
						<span class="underline items-end inline-flex text-zms-optical-black">
							<Icon icon={mobile} class="inline-block mr-2 sm:mr-3 w-5 h-5 sm:w-6 sm:h-6 text-zms-blue" />
							<a class="font-semibold text-xs sm:text-sm/[1.5]" href={`tel:${cleanPhoneNumber(contact.mobile)}`}
								>{formatPhoneNumber(contact.mobile)}</a
							>
						</span>
					{/if}
					{#if contact.email}
						<span class="underline items-end inline-flex text-zms-optical-black">
							<Icon icon={email} class="inline-block mr-2 sm:mr-3 w-5 h-5 sm:w-6 sm:h-6 text-zms-blue" />
							<a class="font-semibold text-xs sm:text-sm/[1.5]" href={`mailto:${contact.email}`}>{contact.email}</a>
						</span>
					{/if}
				</div>
			</div>
		{/each}
	</div>
</section>
